function normalizeTokens(items: string[]): string[] {
  return items
    .map((item) => item.trim().toUpperCase().replace(/[\s_]+/g, '-'))
    .filter(Boolean);
}

function hasAny(items: string[], candidates: string[]): boolean {
  return candidates.some((candidate) => items.includes(candidate));
}

export interface ConnectorDestinationFocus {
  connectorBindings: boolean;
  bomSettings: boolean;
  componentsSettings: boolean;
}

export function resolveConnectorDestinationFocus(items: string[]): ConnectorDestinationFocus {
  const normalized = normalizeTokens(items);
  if (normalized.length === 0) {
    return {
      connectorBindings: true,
      bomSettings: true,
      componentsSettings: true,
    };
  }

  return {
    connectorBindings: hasAny(normalized, [
      'ENDPOINT1',
      'ENDPOINT2',
      'ENDPOINT3',
      'ENDPOINT4',
      'END-POINT-1',
      'END-POINT-2',
      'END-POINT-3',
      'END-POINT-4',
      'END-TYPE-1',
      'END-TYPE-2',
      'END-TYPE-3',
      'END-TYPE-4',
    ]),
    bomSettings: hasAny(normalized, [
      'MATERIAL',
      'DESIGN-STANDARD',
      'DESIGN-STD',
      'PRESSURE-CLASS',
    ]),
    componentsSettings: hasAny(normalized, [
      'INSULATION-SPEC',
      'INSULATIONTHICKNESS',
      'INSULATION-THICKNESS',
      'TRACING-SPEC',
      'ITEM-DESCRIPTION',
    ]),
  };
}

export interface ProcessDestinationFocus {
  processConditions: boolean;
  projectProperties: boolean;
}

export function resolveProcessDestinationFocus(items: string[]): ProcessDestinationFocus {
  const normalized = normalizeTokens(items);
  if (normalized.length === 0) {
    return {
      processConditions: true,
      projectProperties: true,
    };
  }

  return {
    processConditions: hasAny(normalized, [
      'PROCESS-CONDITION',
      'PIPING-SPEC',
      'TRACING-SPEC',
      'ATTRIBUTE12',
      'ATTRIBUTE13',
      'ATTRIBUTE14',
      'ATTRIBUTE15',
      'ATTRIBUTE16',
      'ATTRIBUTE17',
      'ATTRIBUTE18',
      'ATTRIBUTE19',
      'ATTRIBUTE20',
      'ATTRIBUTE21',
      'ATTRIBUTE22',
      'ATTRIBUTE23',
    ]),
    projectProperties: hasAny(normalized, [
      'PROJECT-PROPERTY',
      'PROJECT-IDENTIFIER',
      'PROJECT-NAME',
      'AREA',
      'ATTRIBUTE1',
      'ATTRIBUTE2',
      'ATTRIBUTE3',
      'ATTRIBUTE4',
      'ATTRIBUTE5',
      'ATTRIBUTE6',
      'ATTRIBUTE7',
      'ATTRIBUTE8',
      'ATTRIBUTE9',
      'ATTRIBUTE10',
    ]),
  };
}

export interface AdditionalCategoriesDestinationFocus {
  valve: boolean;
  supports: boolean;
  instrument: boolean;
}

export function resolveAdditionalCategoriesDestinationFocus(
  items: string[]
): AdditionalCategoriesDestinationFocus {
  const normalized = normalizeTokens(items);
  if (normalized.length === 0) {
    return {
      valve: true,
      supports: true,
      instrument: true,
    };
  }

  return {
    valve: hasAny(normalized, ['VALVE', 'VALVE-TAG']),
    supports: hasAny(normalized, ['SUPPORTS', 'SUPPORTS-TAG', 'SSREF']),
    instrument: hasAny(normalized, ['INSTRUMENT', 'INSTRUMENT-TAG']),
  };
}
